import styled from 'styled-components';
import BackgroundBase from './BackgroundBase'
import triangleTowardBottom from '../images/triangle-toward-bottom.svg'

const BackgroundTriangleBottomCenter = styled(BackgroundBase)`
  background: url(${triangleTowardBottom}) center bottom no-repeat;
`;

export default BackgroundTriangleBottomCenter